import React from 'react';

function PaginationClassic({ currentPage, totalPages, onPageChange }) {
  const handlePreviousPage = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      onPageChange(currentPage + 1);
    }
  };

  return (
    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between">
      <nav className="mb-4 sm:mb-0 sm:order-1" role="navigation" aria-label="Navigation">
        <ul className="flex justify-center">
          <li className="ml-3 first:ml-0">
            <button
              className={`btn bg-white dark:bg-gray-800 border-gray-200 dark:border-gray-700/60 text-gray-800 dark:text-gray-300 ${currentPage === 1 ? 'text-gray-300 dark:text-gray-600' : ''}`}
              onClick={handlePreviousPage}
              disabled={currentPage === 1}
            >
              &lt;- Tidligere
            </button>
          </li>
          <li className="ml-3 first:ml-0">
            <button
              className={`btn bg-white dark:bg-gray-800 border-gray-200 dark:border-gray-700/60 hover:border-gray-300 dark:hover:border-gray-600 text-gray-800 dark:text-gray-300 ${currentPage === totalPages ? 'text-gray-300 dark:text-gray-600' : ''}`}
              onClick={handleNextPage}
              disabled={currentPage === totalPages}
            >
              Næste -&gt;
            </button>
          </li>
        </ul>
      </nav>
      <div className="text-sm text-gray-500 text-center sm:text-left">
        Side <span className="font-medium text-gray-600 dark:text-gray-300">{currentPage}</span> af <span className="font-medium text-gray-600 dark:text-gray-300">{totalPages}</span>
      </div>
    </div>
  );
}

export default PaginationClassic;